import Icon from './Icon';

const base =
  'group inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full font-semibold transition-all duration-200 disabled:cursor-not-allowed disabled:opacity-60';

const variants = {
  primary:
    'bg-white text-ink-950 shadow-[0_8px_30px_-10px_rgba(165,180,252,0.6)] hover:bg-indigo-100 hover:shadow-[0_10px_34px_-8px_rgba(165,180,252,0.75)]',
  secondary:
    'border border-white/15 bg-white/[0.04] text-fg hover:border-white/30 hover:bg-white/[0.09]',
};

const sizes = {
  md: 'h-11 px-5 text-sm',
  lg: 'h-12 px-7 text-[15px]',
};

/**
 * Renders an <a> when `href` is provided, otherwise a <button>.
 * External links open in a new tab safely.
 */
const Button = ({
  href,
  external = false,
  variant = 'primary',
  size = 'md',
  arrow = false,
  className = '',
  children,
  ...rest
}) => {
  const classes = `${base} ${variants[variant]} ${sizes[size]} ${className}`;
  const content = (
    <>
      {children}
      {arrow && (
        <Icon
          name={external ? 'ArrowUpRight' : 'ArrowRight'}
          className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5"
          strokeWidth={2.25}
        />
      )}
    </>
  );

  if (href) {
    const linkProps = external ? { target: '_blank', rel: 'noopener noreferrer' } : {};
    return (
      <a href={href} className={classes} {...linkProps} {...rest}>
        {content}
      </a>
    );
  }

  return (
    <button type="button" className={classes} {...rest}>
      {content}
    </button>
  );
};

export default Button;
